<div class="indicator pb-3"*transloco="let t">
  <div class="progress-value">
    <p class="font-weight-bold">{{titleText ? titleText : t(titleTranslationKey)}}</p>
    <p>{{value}}{{unit}}</p>
  </div>
  <progressbar [value]="value"></progressbar>
  <!-- <p>Time left in the course: <span>44</span>min</p> -->
</div>